export default from './Pictures';



// WEBPACK FOOTER //
// ./src/containers/Pictures/index.js